/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CapabilitiesDTO } from './capabilities-dto';


export interface TipoPraticaOperatoreAssegnazioneItem { 
    user_id: string;
    capabilities: CapabilitiesDTO;
}

